import { render, staticRenderFns } from "./RefundLogModal.vue?vue&type=template&id=2edc8f1b&"
import script from "./RefundLogModal.vue?vue&type=script&lang=js&"
export * from "./RefundLogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports